import {styled} from '@esgi/ui/theme';
import {FlexBox} from '@esgi/ui/layout';
import {Menu, MenuItem} from '@esgi/ui-kit/menu';

export const ReportHeader = styled(FlexBox, {
	width: '100%',
	textAlign: 'left',
	borderRadius: '6px 6px 0px 0px',
	color: 'white',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	position: 'relative',
});

export const ReportName = styled('div', {
	fontSize: '16px',
	width: '100%',
});

export const PrintDownloadButtons = styled('div', {
	fontSize: '15px',
	display: 'flex',
	alignItems: 'center',
	position: 'absolute',
	right: 0,
});
export const DownloadButton = styled('div', {
	paddingRight: '10px',
	cursor: 'pointer',
	'ul': {
		marginTop: '8px',
		minWidth: '92px',
		border: 'none',
		padding: 0,
		left: '-54px',

		'li span': {
			color: '#333333',
			width: '190px',
			paddingTop: '7px',
			fontSize: '12px',
			textDecoration: 'none',
			display: 'flex',
			flexDirection: 'column',
			whiteSpace: 'normal',

			'div': {
				textAlign: 'left',

				'&:first-child': {
					fontWeight: 'bold',
				},
			},
		},
	},
});

export const DownloadIcon = styled('i', {
	marginRight: '5px',
});

export const DownloadMenu = styled(Menu, {
	position: 'absolute',
	zIndex: 100000,
});